import { type ActionFunction } from "react-router-dom";

export interface PasswordRecoveryActionData {
  success?: boolean;
  errors?: {
    email?: string;
  };
}

export const passwordRecoveryAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const email = formData.get("email");

  if (!email) {
    return null;
  }

  const response = await fetch(
    `${import.meta.env.VITE_API_BASE_URL}/reset-password-init`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email.toString(),
      }),
    },
  );

  if (response.status !== 204) {
    const errorBody = await response.json().catch(() => ({}));
    const messages = errorBody.message;

    if (Array.isArray(messages) && messages.includes("invalid_email")) {
      return { errors: { email: "invalid_email" } } as PasswordRecoveryActionData;
    }

    return { errors: { email: "unknown_error" } } as PasswordRecoveryActionData;
  }

  return { success: true } as PasswordRecoveryActionData;
};
